import errorPopUp from "./error-popup";

export default errorPopUp;